import { useState } from "react";

const useShortcut = (initialValue) => {
  const [value, setValue] = useState(initialValue || {});

  const handleChange = (newValue, property) => {
    setValue({ ...value, [property]: newValue });
  };
  return {
    ...value,
    setValue: setValue,
    handleChange,
  };
};

export default useShortcut;
